module.exports = " <highcharts-chart [Highcharts]=\"Highcharts\" [options]=\"chartOptions\" style=\"height: 230px; display: block;\">\n</highcharts-chart>"